import React, { useRef, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import { CircularProgress } from '@material-ui/core';
import { MyDropzone } from './DragAndDrop';
import { MyDropzoneRef } from '../../lib/helpers/Dropzone';

const PaperComponent = (props) => {
    return (
        <Draggable handle="#upload-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
};

interface UploadDialogProps {
    isOpen: boolean;
    handleClose: () => void;
    onUploadSuccess?: () => void;
}

const UploadDialog = ({ isOpen, handleClose, onUploadSuccess }: UploadDialogProps) => {
    const dropzoneRef = useRef<MyDropzoneRef>(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const handleProcess = async () => {
        if (dropzoneRef.current) {
            setIsProcessing(true);
            const success = await dropzoneRef.current.handleProcess();

            if (success) {
                setUploadSuccess(true);
                setSuccessMessage('Files uploaded successfully! Refreshing data...');

                setTimeout(() => {
                    handleClose();
                    if (onUploadSuccess) {
                        onUploadSuccess();
                    }
                }, 1500);
            } else {
                setIsProcessing(false);
            }
        }
    };

    const handleDialogClose = () => {
        if (!isProcessing) {
            handleClose();
        }
    };

    return (
        <Dialog
            open={isOpen}
            onClose={handleDialogClose}
            PaperComponent={PaperComponent}
            aria-labelledby="upload-dialog-title"
            maxWidth="md"
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="upload-dialog-title">
                Upload Sailing Schedule
            </DialogTitle>
            <DialogContent>
                {uploadSuccess ? (
                    <div style={{
                        backgroundColor: '#4caf50',
                        color: 'white',
                        padding: '20px',
                        borderRadius: '4px',
                        textAlign: 'center',
                        fontSize: '16px',
                        margin: '20px 0'
                    }}>
                        {successMessage}
                    </div>
                ) : (
                    <MyDropzone
                        ref={dropzoneRef}
                        onUploadStart={() => setIsProcessing(true)}
                        onUploadComplete={(success, message) => {
                            if (!success) {
                                setIsProcessing(false);
                            }
                        }}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleDialogClose}
                    color="primary"
                    disabled={isProcessing || uploadSuccess}
                >
                    Close
                </Button>
                <Button
                    onClick={handleProcess}
                    variant="contained"
                    color="primary"
                    disabled={isProcessing || uploadSuccess}
                >
                    {isProcessing ? (
                        <>
                            <CircularProgress size={20} style={{ marginRight: '8px' }} />
                            Processing...
                        </>
                    ) : 'Process'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UploadDialog;